import {Logger} from "../logging/logger";

export function convertToLocalUtcDate(utcDate: Date | undefined):  Date | undefined {
  Logger.debug("UTC date before converting", utcDate);
  if (!utcDate) {
    return undefined;
  }
  const timeZoneOffset = utcDate.getTimezoneOffset();

  const localDate = new Date(utcDate.getTime() - timeZoneOffset * 60 * 1000);
  Logger.debug("UTC date after converting", localDate);
  return localDate;
}
